import { IconName } from "@formant/ui/component/common/Icon";

import { JsonSchema } from "./JsonSchemaForm/types";

export interface IGetDate {
    type: "request_date";
    module: string;
    minTime?: Date;
    maxTime?: Date;
    time?: Date;
}

export interface IPrompt {
    type: "prompt";
    promptId: string;
    schema: JsonSchema;
    okText?: string;
    cancelText?: string;
}

export interface IGoToTime {
    type: "go_to_time";
    time: number;
}

export interface IGoToDevice {
    type: "go_to_device";
    deviceId: string;
}

export interface IRequestModuleData {
    type: "request_module_data";
    module: string;
}

export interface ISetModuleTimeRange {
    type: "set_module_data_time_range";
    module: string;
    before: number;
    after: number;
}

export interface IShowMessage {
    type: "show_message";
    message: string;
}

export interface IRefreshAuthToken {
    type: "refresh_auth_token";
    module: string;
}

export interface ISetupModuleMenus {
    type: "setup_module_menus";
    module: string;
    menus: { label: string; icon?: IconName }[];
}

export interface ISendChannelData {
    type: "send_channel_data";
    channel: string;
    source: string;
    data: any;
}

export interface IRequestDevices {
    type: "request_devices";
}

export interface IFormantOnline {
    type: "formant_online";
}

export type VisualizationMessage =
    | IGoToTime
    | IGoToDevice
    | IRequestModuleData
    | ISetModuleTimeRange
    | IShowMessage
    | IRefreshAuthToken
    | ISendChannelData
    | ISetupModuleMenus
    | IPrompt
    | IRequestDevices
    | IGetDate
    | IFormantOnline;

export type VisualizationMessageType = VisualizationMessage["type"];

const visualizationMessageTypes: string[] = [
    "go_to_device",
    "go_to_time",
    "prompt",
    "refresh_auth_token",
    "request_date",
    "request_devices",
    "request_module_data",
    "send_channel_data",
    "set_module_data_time_range",
    "setup_module_menus",
    "show_message",
] satisfies VisualizationMessageType[];

export const isVisualizationMessage = (
    it: unknown,
): it is VisualizationMessage =>
    typeof it === "object" &&
    it !== null &&
    "type" in it &&
    typeof it.type === "string" &&
    visualizationMessageTypes.includes(it.type);
